import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LandingPage from './LandingPage';
import CircularLoading from '../components/CircularLoading';
import { isPartnerComingSoon, isPartnerMaintenance, resolvePartnerConfig } from '../common/partnerUtils';
import PartnerUpsellPage from './PartnerUpsellPage';
import PartnerMaintenancePage from './PartnerMaintenancePage';
import PartnerComingSoonPage from './PartnerComingSoonPage';

export default function PartnerLandingPage() {
  const { partnerSlug } = useParams();
  const settings = useSelector(state => state.settingsdata.settings);
  const auth = useSelector(state => state.auth);
  const isAdmin = auth?.profile?.usertype === 'admin' || auth?.profile?.usertype === 'fleetadmin';

  const partner = useMemo(() => resolvePartnerConfig(settings, partnerSlug), [settings, partnerSlug]);

  if (!settings) {
    return <CircularLoading />;
  }

  if (!partner) {
    return (
      <div style={{ padding: 32 }}>
        <h2>Partner page not found</h2>
        <p>Please check the URL or contact the business.</p>
      </div>
    );
  }

  if (isPartnerComingSoon(partner) && !isAdmin) {
    return <PartnerComingSoonPage partner={partner} />;
  }

  if (isPartnerMaintenance(partner) && !isAdmin) {
    return <PartnerMaintenancePage partner={partner} />;
  }

  if (partner.inactive) {
    return <PartnerUpsellPage partner={partner} />;
  }

  return (
    <LandingPage
      partner={partner}
      homePath={`/partners/${partnerSlug}`}
      bookingPath={`/partners/${partnerSlug}/book`}
    />
  );
}
